import { render, staticRenderFns } from "./noticePop.vue?vue&type=template&id=654f7587"
import script from "./noticePop.vue?vue&type=script&lang=js"
export * from "./noticePop.vue?vue&type=script&lang=js"
import style0 from "./noticePop.vue?vue&type=style&index=0&id=654f7587&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('654f7587')) {
      api.createRecord('654f7587', component.options)
    } else {
      api.reload('654f7587', component.options)
    }
    module.hot.accept("./noticePop.vue?vue&type=template&id=654f7587", function () {
      api.rerender('654f7587', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/main/noticePop.vue"
export default component.exports